import React from "react";

export default function SearchIcon({
  size = 18,
  color = "#000000",
  strokeWidth = 2.5,
  className,
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      role="img"
      {...props}
    >
      <polyline points="5 8.45 10 13.45 15 8.45" />
    </svg>
  );
}
